/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartBuildUploadSchema
 */
export interface StartBuildUploadSchema {
    /**
     * 
     * @type {number}
     * @memberof StartBuildUploadSchema
     */
    parts: number;
    /**
     * 
     * @type {boolean}
     * @memberof StartBuildUploadSchema
     */
    useCreds?: boolean;
}

/**
 * Check if a given object implements the StartBuildUploadSchema interface.
 */
export function instanceOfStartBuildUploadSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "parts" in value;

    return isInstance;
}

export function StartBuildUploadSchemaFromJSON(json: any): StartBuildUploadSchema {
    return StartBuildUploadSchemaFromJSONTyped(json, false);
}

export function StartBuildUploadSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartBuildUploadSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parts': json['parts'],
        'useCreds': !exists(json, 'use_creds') ? undefined : json['use_creds'],
    };
}

export function StartBuildUploadSchemaToJSON(value?: StartBuildUploadSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parts': value.parts,
        'use_creds': value.useCreds,
    };
}

